import { RequestLanguage } from '@innowise-group/core';

// UI-only option of the candidate country select; it is sent to the backend as an empty location.
export const ANY_CANDIDATE_LOCATION = 'ANY_LOCATION';

export const requestDefaultLanguage: RequestLanguage = { language: '', level: '' };
